import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42jXJuwrAIAxA0ZgmjdoO7WIpFIrOPkDw/39NHTxwpwswBM2+WEnJSsyjdup6IBpYDKK8O7lf+HuY3E3bxUrRfB19oAMjwRqLRgAAAABJRU5ErkJggg=="};
